import { render, staticRenderFns } from "./SwiperUnder.vue?vue&type=template&id=7bda55b6&scoped=true"
import script from "./SwiperUnder.vue?vue&type=script&lang=js"
export * from "./SwiperUnder.vue?vue&type=script&lang=js"
import style0 from "./SwiperUnder.vue?vue&type=style&index=0&id=7bda55b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bda55b6",
  null
  
)

export default component.exports